import { render, staticRenderFns } from "./ModalReviewEdit.vue?vue&type=template&id=3969a91c&scoped=true"
import script from "./ModalReviewEdit.vue?vue&type=script&lang=js"
export * from "./ModalReviewEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalReviewEdit.vue?vue&type=style&index=0&id=3969a91c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3969a91c",
  null
  
)

export default component.exports